var React = require('react')
var Language = require('./Language')
var Link = require('react-router').Link
 var getAdAction = require('../../actions/getAdAction');
var LanguageStore = require('../../store/LanguageStore')

var languageAction = require('../../actions/languageAction');
var $ = require('jquery')

  var Navigation = React.createClass({
  componentDidMount() {
    LanguageStore.addChangeListener(this.onChange);
    getAdAction.getGodIzvlist('god_izv');
    getAdAction.getAdlist('ad');
    var url = this.props.routes[0].path;
    var lang = url === '/' ? 'rs' : url.slice(1, -1)
    languageAction.setLanguage(lang);
  },
  getInitialState() {
        var state = LanguageStore.getLanguage();
        return state;
    },
    onChange() {
        var state = LanguageStore.getLanguage();
        this.setState(state);

    },
    componentWillUnmount() {
        LanguageStore.removeChangeListener(this.onChange);
    },
  render() {
    return this.state.lang === 'rs' ? this.contentSrb() : this.state.lang === 'uk' ? this.contentEng() : this.state.lang === 'de' ? this.contentGer  () : this.contentSrb()
  },
  contentSrb(){

    return(
    <nav className="navbar navbar-default navbar-top">
    <Link to='/'>
      <div className="col-md-2 text-center">
        <img className="logo" src="css/logo.png" alt='Logo Termovent SC Livnica čelika AD'/>
      </div>
    </Link>
      <div className="col col-md-10">
        <div className="navbar-header">
          <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand" href="#"></a>
        </div>
        <div id="navbar" className="collapse navbar-collapse">
          <ul className="nav navbar-nav navbar-right">
            <li NameName=" "><Link to='/' className='text-center'><p className='text-center'><img className='menu-icon' src='img/icons/home.png'/></p>POČETNA</Link></li>
            <li className="" ><Link to='sertifikati' className='text-center'><p className='text-center'><img className='menu-icon' src='img/icons/certificate.png'/></p>SERTIFIKATI</Link></li>
            <li className="dropdown bkg_hvr">
              <a href="#" className="dropdown-toggle text-center" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><p className='text-center'><img className='menu-icon' src='img/icons/file.png'/></p>O KOMPANIJI <span className="caret"></span></a>
              <ul className="dropdown-menu">
                  <li className="" ><Link to='o-nama'>O NAMA</Link></li>
                  <li className="" ><Link to='galerija'> GALERIJA</Link></li>

                  <li role="separator" className="divider"></li>
                   <li className="" ><Link to='vazna-dokumenta'>VAŽNA DOKUMENTA</Link></li>
                   <li className="" ><Link to='akcionarsko-drustvo'>AKCIONARSKO DRUSTVO</Link></li>
                </ul>
            </li>
            <li className="text-center"><Link to='reference'><p className='text-center'><img className='menu-icon' src='img/icons/reference.png'/></p>REFERENCE</Link></li>
            <li className="text-center"><Link to='proizvodi'><p className='text-center'><img className='menu-icon' src='img/icons/products.png'/></p>PROIZVODI</Link></li>
            {/*<li className=""><Link to='desavanja'><p className='text-center'><span className='glyphicon glyphicon-globe'></span></p>DEŠAVANJA</Link></li>*/}
            <li className="text-center"><Link to='kontakt'><p className='text-center'><img className='menu-icon' src='img/icons/contact.png'/></p>KONTAKT</Link></li>
          </ul>
        </div>

      </div>

      <div className='language'>
      <ul >
        <li><Language {...this.props} language={'/'} /></li>
        <li><Language {...this.props} language={'/uk/'} /></li>
        <li><Language {...this.props} language={'/de/'} /></li>
      </ul>
      </div>
    </nav>
    )
  },
  contentEng(){

    return(
    <nav className="navbar navbar-default navbar-top">
    <Link to='/uk/'>
      <div className="col-md-2 text-center">
        <img className="logo" src="css/logo.png" alt='Logo of Termovent SC Steel foundry J.S.C'/>
      </div>
    </Link>
      <div className="col col-md-10">
        <div className="navbar-header">
          <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand" href="#"></a>
        </div>
        <div id="navbar" className="collapse navbar-collapse">
          <ul className="nav navbar-nav navbar-right">
            <li NameName=" "><Link to='/uk/' className='text-center'><p className='text-center'><img className='menu-icon' src='img/icons/home.png'/></p>HOME</Link></li>
            <li className="" ><Link to='/uk/certificates' className='text-center'><p className='text-center'><img className='menu-icon' src='img/icons/certificate.png'/></p>CERTIFICATES</Link></li>
            <li className="dropdown bkg_hvr">
              <a href="#" className="dropdown-toggle text-center" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><p className='text-center'><img className='menu-icon' src='img/icons/file.png'/></p>ABOUT COMPANY <span className="caret"></span></a>
              <ul className="dropdown-menu">
                  <li className="" ><Link to='/uk/about-us'>ABOUT US</Link></li>
                  <li className="" ><Link to='/uk/gallery'>GALLERY</Link></li>
                </ul>
            </li>
            <li className="text-center"><Link to='/uk/references'><p className='text-center'><img className='menu-icon' src='img/icons/reference.png'/></p>REFERENCES</Link></li>
            <li className="text-center"><Link to='/uk/products'><p className='text-center'><img className='menu-icon' src='img/icons/products.png'/></p>PRODUCTS</Link></li>
            {/*<li className=""><Link to='/uk/desavanja'><p className='text-center'><span className='glyphicon glyphicon-globe'></span></p>EVENTS</Link></li>*/}
            <li className="text-center"><Link to='/uk/contact'><p className='text-center'><img className='menu-icon' src='img/icons/contact.png'/></p>CONTACT</Link></li>
          </ul>
        </div>

      </div>

      <div className='language'>
      <ul >
        <li><Language {...this.props} language={'/'} /></li>
        <li><Language {...this.props} language={'/uk/'} /></li>
        <li><Language {...this.props} language={'/de/'} /></li>
      </ul>
      </div>
    </nav>
    )
  },
   contentGer(){
    return(
    <nav className="navbar navbar-default navbar-top">
    <Link to='/de/'>
      <div className="col-md-2 text-center">
        <img className="logo" src="css/logo.png" alt='Logo von Termovent SC Stahlfabrik GmbH'/>
      </div>
    </Link>
      <div className="col col-md-10">
        <div className="navbar-header">
          <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target=".navbar-collapse" aria-expanded="false" aria-controls="navbar">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a className="navbar-brand" href="#"></a>
        </div>
        <div id="navbar" className="collapse navbar-collapse">
          <ul className="nav navbar-nav navbar-right">
            <li NameName=" "><Link to='/de/' className='text-center'><p className='text-center'><img className='menu-icon' src='img/icons/home.png'/></p>STARTSITE</Link></li>
            <li className="" ><Link to='/de/zertifikate' className='text-center'><p className='text-center'><img className='menu-icon' src='img/icons/certificate.png'/></p>ZERTIFIKATE</Link></li>
            <li className="dropdown bkg_hvr">
              <a href="#" className="dropdown-toggle text-center" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"><p className='text-center'><img className='menu-icon' src='img/icons/file.png'/></p>ÜBER UNS<span className="caret"></span></a>
              <ul className="dropdown-menu">
                  <li className="" ><Link to='/de/uberdas'>ÜBER UNS</Link></li>
                  <li className="" ><Link to='/de/galerie'>GALERIE</Link></li>
                </ul>
            </li>
            <li className="text-center"><Link to='/de/referenzen'><p className='text-center'><img className='menu-icon' src='img/icons/reference.png'/></p>REFERENZEN</Link></li>
            <li className="text-center"><Link to='/de/produkte'><p className='text-center'><img className='menu-icon' src='img/icons/products.png'/></p>DIE PRODUKTE</Link></li>
            {/*<li className=""><Link to='/de/desavanja'><p className='text-center'><span className='glyphicon glyphicon-globe'></span></p>EVENTS</Link></li>*/}
            <li className="text-center"><Link to='/de/kontakt'><p className='text-center'><img className='menu-icon' src='img/icons/contact.png'/></p>KONTAKT</Link></li>
          </ul>
        </div>

      </div>

      <div className='language'>
      <ul >
        <li><Language {...this.props} language={'/'} /></li>
        <li><Language {...this.props} language={'/uk/'} /></li>
        <li><Language {...this.props} language={'/de/'} /></li>
      </ul>
      </div>
    </nav>
    )
  }

})
module.exports = Navigation;



/** WEBPACK FOOTER **
 ** ./modules/components/Navigation/Navigation.js
 **/